import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import AgencyHome from "@/pages/AgencyHome";
import FacebookLanding from "@/pages/FacebookLanding";
import CaseStudy from "@/pages/CaseStudy";
import BulkDiscover from "@/pages/BulkDiscover";
import Demo from "@/pages/Demo";
import LegalPage from "@/pages/LegalPage";
import Pipeline from "@/pages/Pipeline";
import Login from "@/pages/Login";
import NotFound from "@/pages/NotFound";
import AdminGuard from "@/components/AdminGuard";
import { API } from "@/lib/api";

function App() {
  useEffect(() => {
    fetch(`${API}/`).catch(() => {});
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<AgencyHome />} />
          <Route path="/free-demo" element={<FacebookLanding />} />
          <Route path="/bridge" element={<FacebookLanding />} />
          <Route path="/privacy" element={<LegalPage />} />
          <Route path="/terms" element={<LegalPage />} />
          <Route path="/case/:slug" element={<CaseStudy />} />
          <Route path="/demo/:demoId" element={<Demo />} />

          {/* Admin */}
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/leads" element={<AdminGuard><BulkDiscover /></AdminGuard>} />
          <Route path="/admin/pipeline" element={<AdminGuard><Pipeline /></AdminGuard>} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
